var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', {
    ref: "wikiWrap",
    staticClass: "wikiViewerWrap"
  }, [_vm.wikiIndex ? _c('WikiIndex', {
    attrs: {
      "indexList": _vm.titleIndex,
      "scrollMode": true
    },
    on: {
      "itemSelect": _vm.checkTitlePosition,
      "mounted": function (data) {
        return _vm.bookmarkInfo = data;
      }
    }
  }) : _vm._e(), _c('div', {
    ref: "scrollWrap",
    staticClass: "contentsWrap",
    on: {
      "scroll": _vm.moveScroll
    }
  }, [_c('section', {
    staticClass: "wikiContents",
    attrs: {
      "data-depth": "0"
    }
  }, [_vm.isProcess.isProcess ? _c('WikiProcessReadOnly', {
    attrs: {
      "item": _vm.Data
    }
  }) : _vm._e()], 1), _c('section', {
    staticClass: "wikiContents",
    attrs: {
      "data-depth": "0"
    }
  }, [_vm.isKeyword.isKeyword ? _c('WikiKeywordReadOnly', {
    attrs: {
      "item": _vm.isKeyword,
      "readonly": true
    }
  }) : _vm._e()], 1), _vm._l(_vm.nodeData, function (data) {
    return _c('WikiContent', {
      attrs: {
        "editor": data
      }
    });
  })], 2), _c('Loading', {
    attrs: {
      "visible": _vm.loading
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }